import React from "react";

const BeemzText = () => {
  return (
    <div style={{ display: "flex", textTransform: "lowercase" }}>
      <span>be</span>
      <span
        style={{
          transform: "matrix(-1, 0, 0, 1, 0, 0)",
          color: "#bb86fc",
        }}
      >
        e
      </span>
      <span>mz</span>
    </div>
  );
};

export default BeemzText;
